import { useState } from 'hooks'
import { createRoot } from 'react-dom/client'

import 'react-querybuilder/dist/query-builder.css'
import { ConditionsBuilder } from './ConditionsBuilder'
import { constants } from './conditionsBuilder.constant'
import { getConditionBuilders } from './conditionsBuilder.selector'

type State = {
	conditionBuilderComponents?: NodeListOf<HTMLElement>
}

export const ConditionBuilderComponent = (() => {
	const { state, setState } = useState<State>()

	const initConditionBuilders = () => {
		const { conditionBuilderComponents } = state

		if (!conditionBuilderComponents) {
			return
		}

		conditionBuilderComponents.forEach((conditionBuilderComponent) => {
			if (!conditionBuilderComponent) {
				return
			}

			const root = createRoot(conditionBuilderComponent)
			root.render(
				<ConditionsBuilder
					target={conditionBuilderComponent}
					getSqlTranslation={conditionBuilderComponent.getAttribute(constants.translations.getSql) || 'Get SQL'}
					saveConditionsTranslation={
						conditionBuilderComponent.getAttribute(constants.translations.saveConditions) || 'Save conditions'
					}
					saveHandlerEndpoint={conditionBuilderComponent.getAttribute(constants.selector.saveHandler) || ''}
					fetchDataEndpoint={conditionBuilderComponent.getAttribute(constants.selector.fetchDataEndpoint) || ''}
					questionnaireId={conditionBuilderComponent.getAttribute(constants.selector.questionnaireId) || ''}
					globalLabelTranslation={
						conditionBuilderComponent.getAttribute(constants.translations.globalLabel) || 'Global condition'
					}
				/>,
			)
		})
	}

	const init = () => {
		setState({ ...getConditionBuilders() })
		initConditionBuilders()
	}

	return {
		init,
	}
})()
